import PeopleSvg  from 'assets/svgs/homesvg/PeopleSvg';
import StatusupSvg  from 'assets/svgs/homesvg/StatusupSvg';
import ReceiptsSvg  from 'assets/svgs/homesvg/ReceiptsSvg'
import MoneySvg  from 'assets/svgs/homesvg/MoneySvg'

import { useSelector } from 'react-redux';



const HomeCard = () => {


const { statsDashboard } = useSelector(state => state.dashboard);

  return (
 <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 w-full cursor-pointer">

  {/* Total Customers */}
  <div className="h-[100px] bg-light2 px-4 py-3 border-b-[3px] border-[#59B29F] flex justify-between shadow-md 
                  hover:shadow-lg hover:-translate-y-1 transition-all duration-200 ease-in-out rounded-md">
    <div className="flex flex-col gap-1.5">
      <p className="text-dark1 font-semibold">Total Customers</p>
      <h2 className="text-[26px] font-bold">{statsDashboard?.headline?.totalCustomers}</h2>
    </div>
    <div className="w-[33px] h-[33px] rounded-md bg-[#4CBD9114] flex justify-center items-center">
      <PeopleSvg />
    </div>
  </div>

  {/* Total Active Inventory */}
  <div className="h-[100px] bg-light2 px-4 py-3 border-b-[3px] border-[#FFD66B] flex justify-between shadow-md 
                  hover:shadow-lg hover:-translate-y-1 transition-all duration-200 ease-in-out rounded-md">
    <div className="flex flex-col gap-1.5">
      <p className="text-dark1 font-semibold">Total Active Inventory</p>
      <h2 className="text-[26px] font-bold">{statsDashboard?.headline?.totalActiveInventory}</h2>
    </div>
    <div className="w-[33px] h-[33px] rounded-md bg-[#FFFAE1] flex justify-center items-center">
      <StatusupSvg />
    </div>
  </div>
  {/* Total Active Inventory */}
  <div className="h-[100px] bg-light2 px-4 py-3 border-b-[3px] border-[#FFD66B] flex justify-between shadow-md 
                  hover:shadow-lg hover:-translate-y-1 transition-all duration-200 ease-in-out rounded-md">
    <div className="flex flex-col gap-1.5">
      <p className="text-dark1 font-semibold">On Installments Inventories</p>
      <h2 className="text-[26px] font-bold">{statsDashboard?.headline?.onInstallmentsInventories}</h2>
    </div>
    <div className="w-[33px] h-[33px] rounded-md bg-[#FFFAE1] flex justify-center items-center">
      <StatusupSvg />
    </div>
  </div>

  {/* Paid Receipts */}
  <div className="h-[100px] bg-light2 px-4 py-3 border-b-[3px] border-[#2D3748] flex justify-between shadow-md 
                  hover:shadow-lg hover:-translate-y-1 transition-all duration-200 ease-in-out rounded-md">
    <div className="flex flex-col gap-1.5">
      <p className="text-dark1 font-semibold">Paid Receipts</p>
      <h2 className="text-[26px] font-bold">{statsDashboard?.headline?.paidInstallments}</h2>
    </div>
    <div className="w-[33px] h-[33px] rounded-md bg-[#DFE1E4] flex justify-center items-center">
      <ReceiptsSvg />
    </div>
  </div>

  {/* Pending Receipts */}
  <div className="h-[100px] bg-light2 px-4 py-3 border-b-[3px] border-[#7EC2FF] flex justify-between shadow-md 
                  hover:shadow-lg hover:-translate-y-1 transition-all duration-200 ease-in-out rounded-md">
    <div className="flex flex-col gap-1.5">
      <p className="text-dark1 font-semibold">Pending Installments</p>
      <h2 className="text-[26px] font-bold">{statsDashboard?.headline?.pendingInstallments}</h2>
    </div>
    <div className="w-[33px] h-[33px] rounded-md bg-[#7EC2FF] bg-opacity-40 flex justify-center items-center">
      <MoneySvg />
    </div>
  </div>

  <div className="h-[100px] bg-light2 px-4 py-3 border-b-[3px] border-[#7EC2FF] flex justify-between shadow-md 
                  hover:shadow-lg hover:-translate-y-1 transition-all duration-200 ease-in-out rounded-md">
    <div className="flex flex-col gap-1.5">
      <p className="text-dark1 font-semibold">Pending Reciepts For Approval</p>
      <h2 className="text-[26px] font-bold">{statsDashboard?.headline?.pendingPaymentsForApproval}</h2>
    </div>
    <div className="w-[33px] h-[33px] rounded-md bg-[#7EC2FF] bg-opacity-40 flex justify-center items-center">
      <MoneySvg />
    </div>
  </div>

</div>


  )
}

export default HomeCard